import {Component} from 'react';
import {connect} from 'react-redux';
import {notification} from 'antd';
import {PropTypes} from 'prop-types';

class GlobalNotificationHandler extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.code && nextProps.code !== null && nextProps.code !== '') {
      this.showNotification(this.context.intl.formatMessage({id: 'errors.' + nextProps.code}), nextProps.status, nextProps.duration);
    } else if (nextProps.message && nextProps.message !== null && nextProps.message !== '') {
      this.showNotification(nextProps.message, nextProps.status, nextProps.duration);
    }
  }

  showNotification(description, status, duration = 5.5) {
    const {clearErrorMessage} = this.props;
    if (status && status === 'ERROR') {
      notification['error']({
        message: this.context.intl.formatMessage({id: 'notifications.failed.request'}),
        description,
        duration: duration,
        onClose: () => clearErrorMessage(),
      });
    }
    else if (status && status === 'WARNING') {
      notification['warning']({
        message: this.context.intl.formatMessage({id: 'notifications.failed.request'}),
        description,
        duration: duration,
        onClose: () => clearErrorMessage(),
      });
    }
    else {
      notification['success']({
        message: this.context.intl.formatMessage({id: 'notifications.success.request'}),
        description,
        onClose: () => clearErrorMessage()
      });
    }
  }

  render() {
    return ('');
  }
}

const mapStateToProps = (state) => {
  const {code, status, message, duration} = state.GlobalNotificationHandler;
  return {
    code,
    status,
    message,
    duration
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearErrorMessage: () => dispatch({type: 'CLEAR_NOTIFICATION'}),
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalNotificationHandler);

GlobalNotificationHandler.contextTypes = {
  intl: PropTypes.object.isRequired,
};
